import { http } from '../api/http';

export type TicketStatus = 'open' | 'in_progress' | 'closed';
export type TicketPriority = 'high' | 'medium' | 'low';

export interface Ticket {
  id: number;
  user: string;
  subject: string;
  status: TicketStatus;
  priority: TicketPriority;
  date: string;
}

export interface SupportStats {
  open: number;
  inProgress: number;
  resolved: number;
}

export interface UpdateTicketStatusRequest {
  status: TicketStatus;
}

export interface ReplyTicketRequest {
  message: string;
}

export interface CreateSupportTicketRequest {
  subject: string;
  message: string;
  priority?: TicketPriority;
  source?: string;
  metadata?: Record<string, any>;
}

export const SupportService = {
  getStats() {
    return http<SupportStats>('/admin/support/stats');
  },

  getRecentTickets(limit = 20) {
    return http<Ticket[]>(`/admin/support/tickets?limit=${encodeURIComponent(String(limit))}`);
  },

  updateTicketStatus(ticketId: number, payload: UpdateTicketStatusRequest) {
    return http<Ticket>(`/admin/support/tickets/${ticketId}/status`, {
      method: 'PATCH',
      body: payload
    });
  },

  reply(ticketId: number, payload: ReplyTicketRequest) {
    return http<{ ok: boolean }>(`/admin/support/tickets/${ticketId}/reply`, {
      method: 'POST',
      body: payload
    });
  },

  createTicket(payload: CreateSupportTicketRequest) {
    return http<{ id: number | string }>('/support/tickets', {
      method: 'POST',
      body: payload
    });
  }
};
